import { useRouter } from "next/router";
export const SolutionSource = () => {
  const router = useRouter();
  const {
    hotel_details_modal,
    id
  } = router.query;
  const solutionSource = hotel_details_modal ? "hotel_details" : id ? "room_flight_page" : "search_results_page";
  return {
    solutionSource
  };
};